import request from '../_helpers/request';

export const ExhibitionNewsService = {
  GetExhibitionNewsAsync,
  GetIndustryNews
};

//获取官方通知
function GetExhibitionNewsAsync() {
    return request({
      url: 'ExhibitionNews/GetExhibitionNewsAsync',
      params: {LangId: localStorage.getItem('currentLangId')},
      method: 'get'
    })
}

//获取行业动态（行业新闻）
// 统一使用 GET 请求，并通过查询参数传递 langId，确保后端正确识别语言
function GetIndustryNews(langId) {
    return request({
      url: 'ExhibitionNews/GetIndustryNews',
      method: 'get',
      params: {
        langId: langId
      }
    })
}
